import { Button, Card, CardBody, CardFooter, Typography } from "@material-tailwind/react";
import { useState } from "react";
import "../../.././i18n";
import { useTranslation } from "react-i18next";
import EmailField from "../../../UIComponents/Form/EmailField";

const ResendActivationCard: React.FC<ResendActivationCardProps> = ({ onClickFunction, setEmailForm, emailError, onEmailErrorClear }) => {
    const [email, setEmail] = useState('');
    const { t } = useTranslation();

    const setEmailOnChange = (email: string) => {
        setEmail(email);
        setEmailForm(email);
    };

    const handleResendActivationClick = () => {
        onClickFunction(email);
    };

    return (
        <Card shadow={false} className="w-[320px] lg:w-[400px] 2xl:w-[500px] h-[260px] lg:h-[235px] 2xl:h-[250px] px-[20px] lg:px-[25px] shadow-4s">
            <CardBody className="p-0">
                <Typography className="uppercase mt-[40px] text-xl 2xl:text-2xl font-bold text-#333333 text-center">
                    {t("ResendActivation")}
                </Typography>
                <div className="mt-[28px] mb-[35px]">
                    <EmailField value={email} onValueChange={setEmailOnChange} errorMessage={emailError} onErrorClear={onEmailErrorClear} />
                </div>
            </CardBody>
            <CardFooter className="p-0">
                <Button id="resendBtn" className="text-[#161616] bg-#FF8136 hover:bg-#FF6104 h-[40px] w-full text-base 2xl:text-lg font-light p-0 uppercase shadow-none hover:shadow-none" onClick={handleResendActivationClick}>
                    {t("Resend")}
                </Button>
            </CardFooter>
        </Card>
    );
}

export default ResendActivationCard;

interface ResendActivationCardProps {
    onClickFunction: (email: string) => void;
    setEmailForm: React.Dispatch<React.SetStateAction<string>>;
    emailError?: string;
    onEmailErrorClear?: () => void;
}
